export const PERSONAL = 'Personal Details'
export const BANK = 'Banking Details'
export const IDENTITY = 'Identity Verification'
export const INCOME = 'Income Verification'
export const ADDRESS = 'Address Verification'
export const PAYMENT_DATE = 'Date Selection'
export const PAYMENT_FREQUENCY = 'Payment Frequency'
export const PLAN_SELECTION = 'Plan Selection'
